import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NextConfig } from '../../../../app-config';
import { SecurityHelper } from '../../../../pages/common/securityHelper';
import swal from 'sweetalert2';
import { OnlineOfflineService } from '../../../../services/online-offline.service';
import { LoginService } from '../../../../pages/login/login.service';
import { SecurityService } from '../../../../pages/security/service/security.service';
import { DbContextService } from '../../../../services/db-context.service';

@Component({
  standalone: false,
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {
  public nextConfig: any;
  public menuClass: boolean;
  public collapseStyle: string;
  public windowWidth: number;
  shipName!: string;

  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavHeaderMobCollapse = new EventEmitter();
  @Output() onNavToggleChat = new EventEmitter();
  public IFSVersion: string = '[EU Test Version 2.2.6.7 (04112026)]';

  public storageUsed: string = '0';
  public storageQuota: string = '0';
  public percentageUsed: number = 0;
  private stop: boolean = false;
  constructor(private loginService: LoginService,
    private securityService: SecurityService,
    readonly onlineOfflineService: OnlineOfflineService, private dbxService: DbContextService) {
    this.nextConfig = NextConfig.config;
    this.menuClass = false;
    this.collapseStyle = 'block';
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() {
    this.shipName = SecurityHelper.GetLoggedInUserData().shipName;

    this.startMonitoring();

  }

  ngOnDestroy(): void {
    this.stop = true;
  }

  private async startMonitoring() {
    while (!this.stop) {
      await this.getbrowserStorage();
      await this.delay(10000);
    }
  }

  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  formatBytes(bytes: any) {
    if (!+bytes) return '0 Bytes'

    const k = 1000;// 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let index = 0;
    while (bytes >= 1000 && index < sizes.length - 1) {
      bytes /= k;
      index++;
    }
    return `${bytes.toFixed(0)} ${sizes[index]}`;
  }

  async getbrowserStorage() {
    if (navigator.storage && navigator.storage.estimate) {
      const quota: any = await navigator.storage.estimate();
      const maxQoutaLimit = 300000000;
      this.storageUsed = this.formatBytes(quota.usage);
      this.storageQuota = this.formatBytes(maxQoutaLimit);
      this.percentageUsed = (quota.usage / maxQoutaLimit) * 100;
    }
  }

  toggleMobOption() {
    this.menuClass = !this.menuClass;

    //IFS-Style Note: this hide right nav when in vertical menu
    //this.collapseStyle = (this.menuClass) ? 'block' : 'none';
    this.collapseStyle = 'block';
  }

  navCollapse() {
    //if (this.windowWidth >= 992) {
    this.onNavCollapse.emit();
    //} else {
    //  this.onNavHeaderMobCollapse.emit();
    //}
  }

  async onCleanClicked(): Promise<void> {
    swal.fire({
      title: 'Clean Site Data',
      html: '<span>Data will be lost for any unsubmitted orders, daily meals, or stocks.<br/>Do you want to proceed?</span>',
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
      .then((result) => {
        if (result.value) {
          this.clearSiteData().then(() => {
            this.getbrowserStorage().then(() => {
              //this.logout();
            });
          });
        }
      });
  }


  async clearSiteData(): Promise<void> {
    console.log("🧹 Starting full site data cleanup...");

    // 1️⃣ Unregister all service workers
    if ("serviceWorker" in navigator) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
          console.log('🧾 Service Worker unregistered: ${ registration.scope }');
        }
      } catch (error) {
        console.warn("⚠️ Failed to unregister service workers:", error);
      }
    }

    // 2️⃣ Delete all IndexedDB databases
    if ("databases" in indexedDB) {
      try {
        const databases = await (indexedDB as any).databases();
        if (databases && databases.length > 0) {
          for (const dbInfo of databases) {
            const name = dbInfo.name;
            if (!name) continue;

            // Close open connection
            await this.dbxService.closedDb();

            // Delete DB
            await this.deleteIndexedDB(name);
          }
        } else {
          console.log("No IndexedDB databases found.");
        }
      } catch (error) {
        console.warn("⚠️ Could not enumerate IndexedDB databases:", error);
      }
    } else {
      console.warn("⚠️ indexedDB.databases() not supported in this browser.");
    }

    // 3️⃣ Clear web storage
    try {
      localStorage.clear();
      sessionStorage.clear();
      console.log("🗂️ Cleared localStorage and sessionStorage.");
    } catch (error) {
      console.warn("⚠️ Failed to clear web storage:", error);
    }

    // 4️⃣ Clear Cache Storage
    if ("caches" in window) {
      try {
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames) {
          await caches.delete(cacheName);
          console.log('🧾 Cache deleted: ${ cacheName }');
        }
      } catch (error) {
        console.warn("⚠️ Failed to clear caches:", error);
      }
    }

    console.log("✅ Site data cleared successfully!");
    console.log("🔄 Reloading page...");

    // 5️⃣ Reload page after short delay to ensure cleanup is complete
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }


  // 🔧 Helper to close any open IndexedDB connection
  async closeIndexedDBConnection(dbName: string): Promise<void> {
    return new Promise((resolve) => {
      const request = indexedDB.open(dbName);
      const version = request.result.version;
      request.onsuccess = () => {
        const db = request.result;
        db.close();
        console.log('🔒 Closed connection to ${dbName}');
        resolve();
      };

      const upg = indexedDB.open(dbName, version + 1);
      upg.onsuccess = () => {
        const db = upg.result;
        db.close();
        console.log('🔒 Closed connection to ${dbName}');
        resolve();
      };

      request.onerror = () => resolve();
    });
  }

  // 🔧 Helper to delete a single IndexedDB database safely
  async deleteIndexedDB(dbName: string): Promise<void> {
    return new Promise((resolve) => {
      const deleteRequest = indexedDB.deleteDatabase(dbName);

      deleteRequest.onblocked = () => {
        console.warn('⚠️ Deletion blocked for ${dbName} — close other tabs.');
      };
      deleteRequest.onerror = () => {
        console.error('❌ Failed to delete database ${dbName}');
        resolve();
      };
      deleteRequest.onsuccess = () => {
        console.log('🗑️ Deleted IndexedDB ${dbName}');
        resolve();
      };
    });
  }

  logout() {
    if (this.onlineOfflineService.isOnline && !SecurityHelper.IsHTTPRequestsUnathorized(false)) {
      this.loginService.logOut().subscribe({
        complete: () => {

          let userName = SecurityHelper.GetLoggedInUserData().username;
          this.securityService.saveIsAuthenticated(userName, false);
          SecurityHelper.GoBackToLoginPage();
        }
      });
    }
    else {

      SecurityHelper.GoBackToLoginPage();
    }
  }

  public navToggleChat() {
    this.onNavToggleChat.emit();
  }
}
